import { quoteNumber, quoteDisplay, quotePrice } from '@/utils/quoteDisplay'

// Same Tencent fields and units as H5 gupiaoDetail.vue; absent values stay absent.
export function indexDetailsFromQuote(info, breadth, code = '') {
  if (!Array.isArray(info) || !(quoteNumber(info[3]) > 0)) return null
  const fields = { open:5, yclose:4, high:33, low:34, vol:36, amount:37, exchangerate:38, pe2:39, flowmarketvalue:44, volratio:49, amplitude:43, marketvalue:45, bookrate:74, week1:67, week4:68, week13:63, week26:70, week52:62 }
  // H5 gzDetail.vue uses different period fields for HK/US; index quotes lack a bid/ask ratio.
  if (/^us/.test(code)) Object.assign(fields, { volratio:64, week1:48, week4:49, week13:55, week26:60, week52:54, bookrate:-1 })
  else if (/^hk/.test(code)) Object.assign(fields, { volratio:50, week1:48, week4:49, week13:62, week26:67, week52:61, bookrate:-1 })
  const details = Object.fromEntries(Object.entries(fields).map(([field, index]) => [field, quoteNumber(info[index])]))
  // These HK index quotes duplicate turnover in fields 36/37; they do not supply share volume.
  if (/^hkHS(?:I|CEI|CCI)$/i.test(code)) details.vol = null
  // The service returns either [name, code, up, flat, down] or { code: [up, flat, down] }.
  const counts = Array.isArray(breadth) ? breadth.slice(2, 5) : breadth && (breadth[code.replace(/^hk/i, '')] || breadth[code])
  for (const [index, field] of ['up', 'unchanged', 'down'].entries()) details[field] = quoteNumber(counts && counts[index])
  return details
}

export function indexDetailDisplay(value, field, code = '') {
  const number = quoteNumber(value)
  if (number == null) return '--'
  const us = /^us/i.test(code), hk = /^hk/i.test(code)
  const currency = us ? '美元' : hk ? '港元' : ''
  if (['open', 'yclose', 'high', 'low'].includes(field)) return quotePrice(number)
  if (['marketvalue', 'flowmarketvalue'].includes(field)) return quoteDisplay(number, '亿' + currency, 1, 0)
  // A/HK index turnover is 万元/万港元; US index turnover is raw USD (not the HK stock schema).
  if (field === 'amount') {
    return quoteDisplay(number, '亿' + currency, us ? 1e8 : 1e4, 2)
  }
  if (field === 'vol') {
    // Match H5's fixed 亿 scale; foreign indices must not inherit its incorrect 手 label.
    return quoteDisplay(number, us || hk ? '亿' : '亿手', 1e8, 2)
  }
  if (['up', 'unchanged', 'down'].includes(field)) return quoteDisplay(number)
  const percent = ['exchangerate', 'amplitude', 'bookrate', 'week13', 'week26', 'week52'].includes(field)
  return quoteDisplay(number, percent ? '%' : '', 1, 2)
}
